import { Component, OnInit } from "@angular/core";
import {
    NgbModalConfig,
    NgbModal,
    NgbModalOptions,
    ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import {
    Router,
    ActivatedRoute,
    NavigationEnd,
    NavigationStart,
} from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";

import { InvoiceService } from "./../../../_services/invoice.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";

@Component({
    selector: "app-upload-preview-nonpo",
    templateUrl: "./upload-preview-nonpo.component.html",
    styleUrls: ["./upload-preview-nonpo.component.scss"],
})
export class UploadPreviewNonpoComponent
    implements OnInit, DirtyCheckComponent
{
    docs = [
        {
            docType: "NO1X",
            description: "NO1X",
        },
        {
            docType: "NO1G",
            description: "NO1G",
        },
    ];

    invoiceDetails: any;
    closeResult: string = "";
    modalOptions: NgbModalOptions;
    loading: boolean = false;
    uploadSuccessful: boolean = false;
    saving: boolean = false;
    uploadInvoice: boolean = false;
    displayName: any;
    hasError: boolean = false;
    imgUrl: string = "";
    typeError: boolean = false;
    sizeError: boolean = false;
    fileTypeError: boolean = false;
    fileSizeError: boolean = false;
    invoiceSaved: boolean = false;
    savingError: boolean = false;
    validationError: boolean = false;
    serverError: boolean = false;
    supportingDocuments: any[] = [];
    agreed = [{ status: false }];
    masterData: any;
    responseData: any;
    isError = false;
    vendorData: any;
    pdfSrc: any;
    invoiceFile: any;
    invoiceDataToSave: any;
    isInvoiceChange: boolean = false;
    isUpdatedData: boolean = false;
    invoiceChanged: boolean = false;
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    barcodeNo: any;
    eLoaderMsg = "";
    formSubmitted = false;
    previousUrl: any;
    companies: any;
    organisations: any;
    configResCompanies: any;
    configResOrg: any;
    totalSizeError = false;
    files: File[];
    supportingDocsAdded = false;
    canSubmitForm = false;
    allDeleted = false;
    isSubmittingInvoice: boolean = false;

    extractedInvoiceNonPo = new FormGroup({
        invoiceType: new FormControl("e-invoice"),
        file: new FormControl(null),

        //reuploadFile: new FormControl(null),
        supportingFiles: new FormControl([]),
        fileSource: new FormControl(""),
        documentSource: new FormControl(""),
        terms_agreed: new FormControl(false),
        emailAddress: new FormControl(null, [
            Validators.required,
            Validators.email,
            Validators.pattern(
                "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
            ),
        ]),
        username: new FormControl(""),
        userID: new FormControl(""),
        companyCode: new FormControl(null, [Validators.required]),
        purchaseOrg: new FormControl(null, [Validators.required]),
        docType: new FormControl(null, [Validators.required]),
    });

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private invoiceService: InvoiceService
    ) {
        this.modalOptions = {
            backdrop: "static",
            backdropClass: "customBackdrop",
            scrollable: true,
        };

        this.router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.previousUrl = val.url;
            }
        });

        // this.route.queryParams.subscribe((params) => {
        //     this.previousUrl = params['returnUrl'];

        // });
    }

    canDeactivate() {
        if (!this.formSubmitted) {
            this.loading = true;
            return false;
        } else {
            return true;
        }
    }

    exitForm() {
        this.loading = false;
        this.formSubmitted = true;
        this.previousUrl =
            this.route.snapshot.queryParams["returnUrl"] || "dashboard";
        //const returnUrl = this.route.snapshot.queryParamMap["returnUrl"];
        console.log(this.previousUrl);
        this.router.navigateByUrl(this.previousUrl);
    }

    cancelExit() {
        this.loading = false;
    }

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    selectDocuments(event: any) {
        const MAX_FILE_SIZE = 25 * 1024 * 1024; // 5MB
        const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 25MB
        const ALLOWED_TYPES = ["application/pdf"];

        this.files = Array.from(event);
        // Calculate the total size of the selected files (in bytes)
        const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

        // Check if the total size exceeds 25 MB
        if (totalSize > MAX_TOTAL_SIZE) {
            this.totalSizeError = true;
            this.sizeError = false;
            this.typeError = false;
        }

        for (const file of this.files) {
            // Check if any individual file size exceeds 5 MB
            if (file.size > MAX_FILE_SIZE) {
                this.sizeError = true;
                this.typeError = false;
                this.totalSizeError = false;
                continue;
            }

            // Filter out any files that are not Word, Excel, or PDF
            if (!ALLOWED_TYPES.includes(file.type)) {
                this.typeError = true;
                this.sizeError = false;
                this.totalSizeError = false;
                continue;
            }
            this.supportingDocuments.push(file);
        }

        if (this.allDeleted === true) {
            if (this.extractedInvoiceNonPo.get("terms_agreed").value === true) {
                this.extractedInvoiceNonPo.patchValue({
                    terms_agreed: false,
                });
            }
        } else {
            this.extractedInvoiceNonPo.patchValue({ terms_agreed: false });
        }

        this.supportingDocsAdded = true;
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        this.supportingDocuments.splice(index, 1);

        if (this.supportingDocuments.length === 0) {
            if (this.extractedInvoiceNonPo.get("terms_agreed").value === true) {
                this.extractedInvoiceNonPo.patchValue({
                    terms_agreed: false,
                });
            }

            this.canSubmitForm = false;
            this.allDeleted = true;
            this.supportingDocsAdded = false;
        }
    }

    checkSupportingDocuments() {
        if (
            this.supportingDocuments.length > 0 &&
            this.extractedInvoiceNonPo.get("terms_agreed").value === false
        ) {
            this.canSubmitForm = true;
        } else {
            this.canSubmitForm = false;
        }
    }

    reUploadInvoice(event: any) {
        if (event.length > 0) {
            const fileUploaded = event[0];

            //console.log(fileUploaded);

            if (fileUploaded.type !== "application/pdf") {
                this.hasError = false;
                this.fileSizeError = false;
                this.fileTypeError = true;
            } else if (fileUploaded.size > 100 * 1024 * 1024) {
                this.fileTypeError = false;
                this.hasError = false;
                this.fileSizeError = true;
            } else {
                this.fileSizeError = false;
                this.fileTypeError = false;

                if (typeof FileReader !== "undefined") {
                    let reader = new FileReader();
                    reader.onload = (e: any) => {
                        this.pdfSrc = e.target.result;
                        //console.log(this.pdfSrc);
                    };
                    let $file: any = fileUploaded;
                    reader.readAsArrayBuffer($file);
                }

                this.extractedInvoiceNonPo.patchValue({
                    fileSource: fileUploaded,
                });

                this.hasError = false;
                this.isInvoiceChange = true;

                const userData = {
                    req: {
                        emailAddress:
                            this.extractedInvoiceNonPo.value.emailAddress,
                        companyCode:
                            this.extractedInvoiceNonPo.value.companyCode,
                        purchaseOrg:
                            this.extractedInvoiceNonPo.value.purchaseOrg,
                        docType: this.extractedInvoiceNonPo.value.docType,
                        items: [{ poNumber: "", itemNo: "", grn: "" }],
                    },
                };

                this.loading = true;
                this.invoiceChanged = true;
                this.formSubmitted = true;

                //console.log(userData);

                //console.log(localStorage.getItem("userSession"));

                const formData: any = new FormData();
                // formData.append('poNumber', this.route.snapshot.params['poNo']);
                formData.append(
                    "sellerCode",
                    localStorage.getItem("vendorCode")
                );
                formData.append(
                    "sessionId",
                    localStorage.getItem("userSession")
                );
                formData.append("invoiceType", "e-invoice");
                formData.append("req", JSON.stringify(userData.req));
                formData.append(
                    "file",
                    this.extractedInvoiceNonPo.value.fileSource
                );

                // for (const value of formData.values()) {
                //     console.log(value);
                // }

                this.eLoaderMsg = "Verifying QR Code";

                setTimeout(() => {
                    this.eLoaderMsg = "Authenticating QR Code";
                }, 5000);
                setTimeout(() => {
                    this.eLoaderMsg = "Extracting Data";
                }, 10000);
                setTimeout(() => {
                    this.eLoaderMsg = "Validating Data";
                }, 15000);

                this.invoiceService.extractInvoice(formData).subscribe(
                    (res) => {
                        this.loading = false;
                        this.invoiceChanged = false;
                        this.isUpdatedData = true;
                        this.responseData = res;
                        this.formSubmitted = false;
                        //console.log(res);
                        if (
                            this.responseData.length !== 0 &&
                            this.responseData.status === "error"
                        ) {
                            console.log(this.responseData.message);
                        } else {
                            //console.log("Success hereresponseData");
                            this.invoiceDetails = this.responseData;
                        }
                    },
                    (error) => {
                        console.log(error.msg);
                    }
                );
            }
        }
    }

    onDrop(event: any) {
        // Update the list order
        moveItemInArray(
            this.supportingDocuments,
            event.previousIndex,
            event.currentIndex
        );
        this.supportingDocsAdded = true;
    }

    open(content: any) {
        this.modalService.open(content, this.modalOptions).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    onSubmit() {
        if (this.isSubmittingInvoice) {
            return;
        }

        this.isSubmittingInvoice = true;
        this.loading = true;
        this.uploadInvoice = true;
        this.formSubmitted = true;

        let userName = this.invoiceService.getUsername();
        let userID = this.invoiceService.getUserId();

        const userData = {
            companyCode: this.invoiceDetails.company_code,
            purchaseOrg: this.invoiceDetails.purchase_org,
            docType: this.invoiceDetails.doc_type,
            emailAddress: this.invoiceDetails.email_address,
            poNumber: "",
            username: userName,
            userId: userID,
            items: [{ poNumber: "", itemNo: "", grn: "" }],
            termsAgreed: true,
        };

        if (this.isInvoiceChange === true) {
            this.invoiceFile = this.extractedInvoiceNonPo.value.fileSource;
        } else {
            this.invoiceFile = this.invoiceService.getFileElement();
        }

        const trimNo = this.invoiceDetails.invoice_number.replace(/\s+/g, "");

        const mapKeys = {
            file_link: this.invoiceDetails.file_link,
            SellerGstin: this.invoiceDetails.gstin,
            BuyerGstin: "",
            DocNo: trimNo,
            DocTyp: "INV",
            DocDt: this.invoiceDetails.invoice_date,
            TotInvVal: this.invoiceDetails.invoice_amount,
            ItemCnt: "",
            MainHsnCode: "",
            Irn: this.invoiceDetails.irn,
            IrnDt: "",
            invType: this.invoiceService.getInvType(),
            invoiceType: this.invoiceService.getInvoiceType(),
        };

        const fileOrder = [];
        this.supportingDocuments.forEach((file, index) => {
            const obj = {};
            obj[(index + 1).toString()] = file.name;
            fileOrder.push(obj);
        });

        //console.log(localStorage.getItem("userSession"));

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("vendorCode"));
        formData.append("sessionId", localStorage.getItem("userSession"));
        formData.append("invType", this.invoiceService.getInvType());
        formData.append("fileOrder", JSON.stringify(fileOrder));
        formData.append("req", JSON.stringify(userData));
        formData.append("data", JSON.stringify(mapKeys));
        //formData.append("file", this.invoiceFile);

        //console.log(this.supportingDocuments);

        if (this.supportingDocuments.length !== 0) {
            for (let i = 0; i < this.supportingDocuments.length; i++) {
                formData.append("supportingDocs", this.supportingDocuments[i]);
            }
        } else {
            formData.append("supportingDocs", this.supportingDocuments);
        }

        // for (const value of formData.values()) {
        //     console.log(value + " This is formdata");
        // }

        if (!this.saving) {
            this.invoiceService
                .uploadInvoiceWithoutExtration(formData)
                .subscribe(
                    (res) => {
                        this.isSubmittingInvoice = false;
                        this.responseData = res;
                        //console.log(this.responseData.status);

                        if (this.responseData.status === "error") {
                            console.log("error exist");
                            this.loading = false;
                            this.uploadInvoice = false;
                            this.hasError = true;
                            this.formSubmitted = false;
                        } else {
                            this.barcodeNo = this.responseData.barcode;
                            const data = {
                                barcode: this.barcodeNo,
                                docTyp: "INV",
                                sellerCode: localStorage.getItem("vendorCode"),
                                session: {
                                    sessionId:
                                        localStorage.getItem("userSession"),
                                },
                            };
                            //console.log(data);

                            this.invoiceService
                                .sendInvoiceToJSW(data)
                                .subscribe(
                                    (res) => {
                                        console.log(res);
                                    },
                                    (error) => {
                                        this.hasError = true;
                                        this.responseData = {
                                            message:
                                                error?.msg ||
                                                error?.message ||
                                                "Unable to process the request. Please try again.",
                                            status: "error"
                                        };
                                    }
                                );
                            console.log("Success");

                            this.uploadSuccessful = true;
                            this.uploadInvoice = false;
                        }
                    },
                    (error) => {
                        this.isSubmittingInvoice = false;
                        this.uploadInvoice = false;
                        this.uploadSuccessful = false;
                        this.invoiceSaved = false;
                        this.serverError = true;
                        this.hasError = true;
                        this.responseData = {
                            message:
                                error?.msg ||
                                error?.message ||
                                "Unable to process request",
                            status: "error"
                        };
                        this.formSubmitted = false;
                        // console.log(error);
                    }
                );
        }

        this.modalService.dismissAll();
        //
    }

    fetchPurchaseOrg() {
        const configReq = {
            configType: "purchaseOrganizations",
            sellerCode: localStorage.getItem("vendorCode"),
            session: {
                sessionId: localStorage.getItem("userSession"),
            },
        };

        this.invoiceService.fetchConfig(configReq).subscribe(
            (res) => {
                this.configResOrg = res;
                if (
                    this.configResOrg.length !== 0 &&
                    this.configResOrg.status === "error"
                ) {
                    console.log(this.configResOrg + " Error");
                } else {
                    this.organisations = this.configResOrg.data;
                }
            },
            (error) => {
                this.hasError = true;
                this.responseData = {
                    message:
                        error?.msg ||
                        error?.message ||
                        "Unable to load configuration. Please try again.",
                    status: "error"
                };
            }
        );
    }

    fetchCompanyCode() {
        const configReq = {
            configType: "companyCodes",
            sellerCode: localStorage.getItem("vendorCode"),
            session: {
                sessionId: localStorage.getItem("userSession"),
            },
        };

        this.invoiceService.fetchConfig(configReq).subscribe(
            (res) => {
                this.configResCompanies = res;
                if (
                    this.configResCompanies.length !== 0 &&
                    this.configResCompanies.status === "error"
                ) {
                    console.log(this.configResCompanies + " Error");
                } else {
                    this.companies = this.configResCompanies.data;
                }
            },
            (error) => {
                this.hasError = true;
                this.responseData = {
                    message:
                        error?.msg ||
                        error?.message ||
                        "Unable to load configuration. Please try again.",
                    status: "error"
                };
            }
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.invoiceDetails = this.invoiceService.getProcessedInvoice();
        this.formSubmitted = false;

        this.fetchCompanyCode();
        this.fetchPurchaseOrg();

        console.log(this.companies);
        console.log(this.invoiceDetails);

        this.extractedInvoiceNonPo.patchValue({
            purchaseOrg: this.invoiceDetails.purchase_org,
            docType: this.invoiceDetails.doc_type,
            emailAddress: this.invoiceDetails.email_address.toLowerCase(),
            companyCode: parseInt(this.invoiceDetails.company_code),
            username: this.invoiceService.getUsername(),
            userID: this.invoiceService.getUserId(),
        });
        this.loadFile();

        // console.log(this.extractedInvoiceNonPo);
        // console.log("Form Data");

        //this.pdfSrc = this.invoiceService.getInvoiceFile();
        //console.log(this.pdfSrc);
        ///this.imgUrl = this.invoiceDetails.file_link;

        // if (this.invoiceDetails.raw.errors.length !== 0) {
        //     this.hasError = true;
        // } else {
        //     this.hasError = false;
        // }

        //console.log(this.invoiceDetails);
    }

    closeSuccessDialog() {
        this.loading = false;
        this.router.navigateByUrl("/invoices");
    }

    closeErrorDialog() {
        this.loading = false;
        this.savingError = false;
        this.serverError = false;
    }

    resubmitInvoice() {
        this.router.navigateByUrl("/submit-nonpo-invoice");
    }

    onCheckboxChange(e: any) {
        //console.log(e);
        if (e.target.checked) {
            this.extractedInvoiceNonPo.patchValue({
                terms_agreed: e.target.value,
            });
        } else {
            this.extractedInvoiceNonPo.patchValue({
                terms_agreed: null,
            });
        }
    }

    loadFile() {
        if (typeof FileReader !== "undefined") {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.pdfSrc = e.target.result;
                //console.log(this.pdfSrc);
            };
            let $file: any = this.invoiceService.getFileElement();
            reader.readAsArrayBuffer($file);
        }

        // this.invoiceFile = new Blob([this.pdfSrc], { type: "application/pdf" });
    }

    viewSavedInvoices() {
        this.router.navigate(["/saved-invoices"]);
    }
}
